import React from 'react';

const Divider = () => {
  return <div className='w-full h-px bg-white/10 my-14' />;
};

export default Divider;
